// src/components/RestriccionMorosidadGuard.js
import React from 'react';
import { useRestriccionMorosidad } from '../hooks/useRestriccionMorosidad';
import './RestriccionMorosidadGuard.css';

/**
 * Componente que protege rutas que pueden ser restringidas por morosidad
 * @param {string} sectionKey - Clave de la sección a proteger ('chat', 'solicitudes', 'amenidades', 'visitas', 'datosContacto')
 * @param {ReactNode} children - Contenido a renderizar si no hay restricción
 */
const RestriccionMorosidadGuard = ({ sectionKey, tabKey, subKey, children }) => {
    const { isSectionRestricted, isTabRestricted, isSubSectionRestricted, loading, userDebt } = useRestriccionMorosidad();

    // Mientras carga, mostrar loader
    if (loading) {
        return (
            <div className="restriccion-loading">
                <div className="spinner"></div>
                <p>Verificando acceso...</p>
            </div>
        );
    }

    let restricted = false;
    if (tabKey && subKey) {
        restricted = isSubSectionRestricted(tabKey, subKey);
    } else if (tabKey) {
        restricted = isTabRestricted(tabKey);
    } else if (sectionKey) {
        restricted = isSectionRestricted(sectionKey);
    }

    // Si la sección está restringida, mostrar mensaje de bloqueo
    if (restricted) {
        return (
            <div className="restriccion-bloqueada">
                <div className="restriccion-card">
                    <div className="restriccion-icon">🚫</div>
                    <h2>Acceso Restringido</h2>
                    <p className="restriccion-message">
                        Esta sección está temporalmente bloqueada debido a que tienes un adeudo pendiente.
                    </p>
                    <div className="restriccion-details">
                        <div className="adeudo-info">
                            <strong>Adeudo actual:</strong>
                            <span className="adeudo-amount">${userDebt.adeudo.toFixed(2)}</span>
                        </div>
                    </div>
                    <p className="restriccion-help">
                        Para recuperar el acceso, por favor ponte al corriente con tus pagos.
                        Si ya realizaste el pago, contacta a tu administrador.
                    </p>
                    <button 
                        className="btn-volver"
                        onClick={() => window.history.back()}
                    >
                        Volver
                    </button>
                </div>
            </div>
        );
    }

    // Si no hay restricción, renderizar el contenido
    return <>{children}</>;
};

export default RestriccionMorosidadGuard;
